/**
 * Applications & consent audit Graph calls (C10) — ported from x365 graph.js,
 * behind the graph/ layer. Typed, least-privilege, zero-egress.
 */
import { graphGetAll } from '@/graph/client';
import { CAPABILITY_SCOPES } from '@/auth/scopes';

const SCOPES = CAPABILITY_SCOPES.C10.scopes;

export const APP_ENDPOINTS = {
  applications: '/applications',
  grants: '/oauth2PermissionGrants',
  servicePrincipals: '/servicePrincipals',
} as const;

export interface AppCredential {
  displayName?: string | null;
  keyId?: string | null;
  endDateTime?: string | null;
}

export interface AppRegistration {
  id: string;
  appId?: string;
  displayName?: string | null;
  signInAudience?: string | null;
  passwordCredentials?: AppCredential[];
  keyCredentials?: AppCredential[];
}

export interface OAuthGrant {
  clientId?: string;
  resourceId?: string;
  consentType?: string;
  scope?: string;
}

export interface ServicePrincipalRef {
  id: string;
  displayName?: string | null;
  appId?: string;
}

export function getApplications(): Promise<AppRegistration[]> {
  return graphGetAll<AppRegistration>(APP_ENDPOINTS.applications, {
    scopes: SCOPES,
    query: {
      $select: 'id,appId,displayName,signInAudience,createdDateTime,passwordCredentials,keyCredentials',
      $top: '100',
    },
  });
}

export function getOAuth2PermissionGrants(): Promise<OAuthGrant[]> {
  return graphGetAll<OAuthGrant>(APP_ENDPOINTS.grants, {
    scopes: SCOPES,
    query: { $top: '200' },
  });
}

export function getServicePrincipals(): Promise<ServicePrincipalRef[]> {
  return graphGetAll<ServicePrincipalRef>(APP_ENDPOINTS.servicePrincipals, {
    scopes: SCOPES,
    query: { $select: 'id,displayName,appId', $top: '200' },
  });
}
